export default __webpack_public_path__ + "3bcd7e5ea0411c07d8ba0fd6fef72d6c.mp3";